<template>
  <router-view />
</template>

<script>
export default {
  name: 'CreateCampaignSource',
}
</script>
